import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import icon from '../assets/checkmarcksvg.svg'
import { CODEMP_MUSIMUNDO } from '../utilities';

const AdditionalBenefits = (benefits) => {

    const { firstStep } = useSelector((state) => state.firstStep);
    const { codemp } = useSelector(state => state.adminReducer.login);
    const [cardSelected, setCardSelected] = useState(false);
    const [isColapsadaVisible, setIsColapsadaVisible] = useState(false);
    const cardClass = cardSelected ? 'card card-selected' : 'card';

    const toggleColapsada = () => {
        setCardSelected(!cardSelected);
        setIsColapsadaVisible((prevVisible) => !prevVisible);
    };

    return (
        <>
            <div className={cardClass}>
                <div style={{ display: 'flex', marginLeft: 6 }}>
                    <div className={CODEMP_MUSIMUNDO.includes(codemp) ? 'badget' : 'badget-cfn'}><img src={icon} style={{ width: "60%" }} alt="Img" /></div>
                    <div>
                        <div style={{ fontWeight: 500, marginLeft: 4 }}>
                            ¡Beneficios adicionales!
                        </div>
                        <p style={{ color: CODEMP_MUSIMUNDO.includes(codemp) ? 'red' : 'blue', marginLeft: 4 }} onClick={toggleColapsada}>
                            {isColapsadaVisible ? 'Menos detalles <' : 'Más detalles >'}
                        </p>
                    </div>
                </div>
            </div>
            {
                isColapsadaVisible && (
                    <div className="cardColapsada">
                        <div className='planText' style={{ marginLeft: 20 }}>
                            <header style={{ color: CODEMP_MUSIMUNDO.includes(codemp) ? 'red' : 'blue' }}>
                                <b style={{ fontWeight: "bold", marginTop: 10 }}>
                                    ¡Contratando tu plan
                                    contás con todos estos beneficios!
                                </b>
                            </header>
                            <p style={{ marginTop: 20 }}>Todos los planes de {firstStep.codsec === '8' ? 'seguro Hogar' : 'Accidentes Personales'} incluyen:</p>
                        </div>
                        <ul className='ulplanText'>
                            {
                                benefits.benefits[firstStep.codsec]?.map((e) => (
                                    <div className={CODEMP_MUSIMUNDO.includes(codemp) ? 'elemento' : 'elemento-cfn'} >
                                        <div style={{ marginLeft: 20, width: 250 }}>
                                            {
                                                e.module !== '' &&
                                                <header style={{ fontSize: 15, color: CODEMP_MUSIMUNDO.includes(codemp) ? 'red' : 'blue' }}><b>{e.module}</b></header>
                                            }
                                            <header style={{ fontSize: 13 }}><b>{e.title}</b></header>
                                            {
                                                e.subtitle !== '' &&
                                                <i style={{ marginBottom: 10, fontSize: 14, fontWeight: 500 }}>{e.subtitle}</i>
                                            }
                                            <section style={{ fontSize: 14, marginTop: 5 }}>{e.body}</section>
                                            <section style={{ fontSize: 14 }}>{e.tope}</section>
                                            {
                                                e.events !== '' &&
                                                <section style={{ fontSize: 14 }}>{e.events}</section>
                                            }
                                            <br />
                                        </div>
                                    </div>
                                ))
                            }
                        </ul>

                    </div >
                )}
        </>
    )
}

export default AdditionalBenefits